import HotelRoomModule from './hotel-room/hotel-room-module';
import ExtraHotelsModule from './extra-hotels/extra-hotels-module';
import DistanceUnitModule from './distance-unit/distance-unit-module';

import HotelInterceptor from './services/hotels.interceptor';

import hotelEvents from './config/hotel-events';
import hotelsRoutes from './hotels-routes';
import hotelSearchParams from './config/hotel-search-params';
import hotelsSuppliers from './config/supplier.constant';
import refundableTypes from './config/refundable-type';

import HotelFiltersController from './controllers/hotelFiltersController';
import HotelSearchFormController from './controllers/hotelSearchForm';

import HotelResultService from './hotel-result-service';

import HotelViewHeaderController from './controllers/hotelViewHeaderCtrl';
import HotelViewMapController from './controllers/hotelViewMapCtrl';

import HotelsFactoryModule from './services/hotels-factory-module';
import PremierInnFormCheckerFactory from './services/premierInnFormChecker';
import TravelodgeFormCheckerFactory from './services/travelodgeFormChecker';

const MODULE_NAME = 'App.Hotels';
const module = angular
    .module(MODULE_NAME, [
        HotelRoomModule,
        HotelsFactoryModule,
        ExtraHotelsModule,
        DistanceUnitModule,
    ])
    .constant('hotelEvents', hotelEvents)
    .constant('HOTEL_SEARCH_PARAMS', hotelSearchParams)
    .constant('HOTELS_SUPPLIERS', hotelsSuppliers)
    .constant('REFUNDABLE_TYPES', refundableTypes)
    .controller('HotelSearchFormController', HotelSearchFormController)
    .controller('HotelFiltersController', HotelFiltersController)
    .controller('HotelViewHeaderController', HotelViewHeaderController)
    .controller('HotelViewMapController', HotelViewMapController)
    .service('hotelResultService', HotelResultService)
    .factory('premierInnFormChecker', PremierInnFormCheckerFactory)
    .factory('travelodgeFormChecker', TravelodgeFormCheckerFactory)
    .config(HotelInterceptor)
    .config(hotelsRoutes);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/hotels/hotels-module.js